import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '🟠',
    title: 'TOMO 1',
    level: 'La Ingeniería de la Masa',
    tagline: 'La base de todo. Acá no hay secretos.',
    content: 'La fórmula exacta de la masa base explicada para principiantes absolutas.',
    bullets: ['Los ingredientes reales y dónde conseguirlos en Argentina', 'Test de elasticidad para saber si tu masa está lista', 'Cómo hacer varillas tradicionales, conitos, peluditos, tornaditos y bicolor', 'Sahumerios negros y maceraciones', 'Colorimetría artesanal', 'Secado y curado profesional para que ninguno se quiebre', 'Los errores más comunes y cómo evitarlos']
  }, {
    emoji: '🟣',
    title: 'TOMO 2',
    level: 'Alquimia y Aromaterapia',
    tagline: 'El alma del producto. Lo que hace que tus clientes vuelvan.',
    content: 'No es solo ponerle olor. Es aromatizar con técnica profesional.',
    bullets: ['El método de doble infusión para que el aroma dure horas', 'Diferencia entre aceites esenciales, fragancias sintéticas y resinas', 'Mezclas funcionales: limpieza energética, relax y sueño, amor, abundancia, foco', 'Sahumerios por signo zodiacal — la línea que más se vende', 'Cómo crear tu propia línea de aromas con identidad de marca']
  }, {
    emoji: '🔴',
    title: 'TOMO 3',
    level: 'Negocio y Ventas 2026',
    tagline: 'La mente financiera. No pierdas plata.',
    content: 'El tomo que convierte tu hobby en un negocio real.',
    bullets: ['Cómo calcular el costo real en pesos argentinos en 2026', 'Fórmula de precios para no regalar tu trabajo', 'Punto de equilibrio: cuánto tenés que vender para que te valga la pena', 'Packaging artesanal que enamora y diferencia tu producto', 'Cómo vender por WhatsApp, Instagram y Marketplace sin saber de tecnología', 'Estrategia para conseguir tus primeros clientes esta semana']
  }];
  const includes = ['Recetas y técnicas listas para aplicar', 'Explicaciones paso a paso para principiantes', 'Tablas, checklists y registros descargables', 'Adaptado al contexto argentino', 'Lenguaje claro y directo', 'Sin términos técnicos difíciles'];
  return <section className="w-full bg-[#FBF5EC] py-4 md:py-8" data-id="element-238">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-239">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-240">
          <div className="text-center mb-3 md:mb-6" data-id="element-241">
            <h2 className="text-3xl md:text-5xl font-bold text-[#3D2817] mb-1 md:mb-2" data-id="element-242">
              🏆 MEGA PACK EL MÉTODO MAESTRO
            </h2>
            <p className="text-lg md:text-xl text-[#7A4A2B] font-semibold mb-1" data-id="element-243">
              Sahumerios de Alta Rentabilidad
            </p>
            <p className="text-xl md:text-2xl text-[#B45309] font-semibold mb-1" data-id="element-244">
              3 Tomos + 2 Bonos — Masa → Negocio en Pesos
            </p>
            <p className="text-2xl md:text-3xl font-bold text-[#3D2817]" data-id="element-245">
              Todo resuelto. Paso a paso. Desde cero.
            </p>
          </div>

          <div className="mb-4 md:mb-6" data-id="element-246">
            <h3 className="text-2xl md:text-3xl font-bold text-[#3D2817] mb-3 md:mb-4 text-center" data-id="element-247">
              📚 LOS 3 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-248">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.5
            }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 md:p-5 relative overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-249">
                  <div className="text-3xl mb-2" data-id="element-250">{tomo.emoji}</div>
                  <h4 className="text-lg font-bold text-[#3D2817] mb-1" data-id="element-251">
                    {tomo.title} — {tomo.level}
                  </h4>
                  <p className="text-[#B45309] font-semibold mb-2 text-sm italic" data-id="element-252">
                    {tomo.tagline}
                  </p>
                  <p className="text-[#6B5747] text-sm leading-relaxed mb-3" data-id="element-253">
                    {tomo.content}
                  </p>
                  <p className="text-[#3D2817] text-sm font-semibold mb-2" data-id="element-254">
                    Aprenderás:
                  </p>
                  <ul className="space-y-1.5" data-id="element-255">
                    {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2" data-id="element-256">
                        <CheckCircleIcon className="w-4 h-4 text-[#5C8A6D] flex-shrink-0 mt-0.5" data-id="element-257" />
                        <span className="text-[#6B5747] text-sm leading-snug" data-id="element-258">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 md:p-6 shadow-sm" data-id="element-259">
            <h3 className="text-lg md:text-xl font-bold text-[#3D2817] mb-2 md:mb-3 text-center" data-id="element-260">
              📋 Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-261">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-262">
                  <CheckCircleIcon className="w-4 h-4 text-[#B45309] flex-shrink-0 mt-0.5" data-id="element-263" />
                  <p className="text-[#6B5747] text-sm" data-id="element-264">{item}</p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}